import React, { Fragment, useEffect, useState } from "react";
import { backend, API_URL } from "../../../config";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Button,
  Modal,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Divider,
  Switch,
  Collapse,
  IconButton,
  useTheme,
  Tooltip,
  Link as LinkE,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Link } from "react-router-dom";

import PrintIcon from "@mui/icons-material/Print";
import MediationIcon from "@mui/icons-material/Mediation";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const columns = [
  {
    id: "hidden",
    label: "Hide Row",
  },
  {
    id: "inventory_item",
    label: "Inventory Item",
  },
  {
    id: "order_item",
    label: "Order Item",
  },
  {
    id: "receipt_item",
    label: "Receipt Item",
  },
  {
    id: "difference",
    label: "Differences",
  },
];

const Difference = (props) => {
  const {
    currentPricing,
    dateRange,
    orders,
    ordersSelected,
    receiptsSelected,
    priceMargin,
    showPricingDifferences,
    rdErrorsSet,
  } = props.location.state ? props.location.state : props;

  const classes = useStyles();
  const theme = useTheme();

  const [ordersIncluded, setOrdersIncluded] = useState([]);
  const [receipts, setReceipts] = useState([]);
  const [rdData, setRdData] = useState(null);
  const [rdDataFull, setRdDataFull] = useState(null);
  const [rdErrors, setRdErrors] = useState([]);
  const [rdErrorsFull, setRdErrorsFull] = useState([]);
  const [rdOrders, setRdOrders] = useState([]); // 4468, 4473 receipt 2023-04-19
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [showHiddenRows, setShowHiddenRows] = useState(false);
  const [hideErrors, setHideErrors] = useState(false);
  const [hideNonErrors, setHideNonErrors] = useState(false);
  const [hiddenRows, setHiddenRows] = useState(0);
  const [displayDetails, setDisplayDetails] = useState(false);
  const [displayPrint, setDisplayPrint] = useState(false);
  const [displayPrintFollow, setDisplayPrintFollow] = useState(false);

  const toggleDisplayPrint = () => setDisplayPrint(!displayPrint);

  const toggleDisplayPrintFollow = () =>
    setDisplayPrintFollow(!displayPrintFollow);

  const toggleDisplayDetails = () => setDisplayDetails(!displayDetails);

  const toggleLoadingModal = () => setLoadingFlag(!loadingFlag);

  const toggleShowHiddenRows = () => setShowHiddenRows(!showHiddenRows);
  const toggleHideErrors = () => {
    setRdErrors(() => (!hideErrors ? [] : rdErrorsFull));
    setHideErrors(!hideErrors);
  };

  const toggleHideNonErrors = () => setHideNonErrors(!hideNonErrors);

  const loadingModalContent = (
    <div className={classes.modal}>
      {loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Calculating receipt information <br />
              This may take some time relative to the number of items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while calculating the receipt information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                <div style={{ overflow: "scroll", width: 400, height: 300 }}>
                  <div
                    dangerouslySetInnerHTML={{ __html: errorInfo.message }}
                  />
                </div>
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => toggleLoadingModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );

  const handleChange = (e) => {
    const { checked, name } = e.target;
    const [, , , uniqId] = name.split("-");

    setHiddenRows((prevState) => (checked ? prevState + 1 : prevState - 1));

    setRdDataFull((prevState) => {
      let differenceGroups = prevState.difference_groups.map((dgItem) => {
        let differencesMap = dgItem.differences;

        const uniqIdFound = differencesMap.find(
          (item) => item.uniqId === +uniqId
        );

        if (uniqIdFound) {
          differencesMap = differencesMap.map((item) => {
            if (item.uniqId === +uniqId)
              return { ...item, hidden: !item.hidden };

            return item;
          });
        }

        return { ...dgItem, differences: differencesMap };
      });

      return { ...prevState, difference_groups: differenceGroups };
    });
  };

  const handleChangeErrorFiltering = (e) => {
    const { checked, value } = e.target;

    if (checked) {
      setRdErrors((prevState) => [...prevState, value]);
    } else {
      setRdErrors((prevState) =>
        prevState.filter((item) => {
          return item !== value;
        })
      );
    }
  };

  const handleChangeOrderFiltering = (e) => {
    const { checked, value } = e.target;

    if (checked) {
      setRdOrders((prevState) => [...prevState, +value]);
    } else {
      setRdOrders((prevState) =>
        prevState.filter((item) => {
          return item !== +value;
        })
      );
    }
  };

  useEffect(() => {
    const rdResultsGet = async () => {
      setLoadingFlag(true);

      const payloadObj = {
        order_ids: ordersIncluded,
        receipt_ids: receipts,
        use_current_pricing: currentPricing,
        price_margin: priceMargin,
        show_pricing_differences: showPricingDifferences,
      };

      await backend
        .post(`${API_URL}receiptdifferenceresult`, payloadObj)
        .then(({ data }) => {
          let rdErrorsArray = [];

          let dataMap = {};

          let uniqueId = 0;

          if (data.difference_groups.length) {
            const differenceGroupsMap = data.difference_groups.map((dgItem) => {
              if (dgItem.difference_categories.length) {
                dgItem.difference_categories.forEach((itemDif) => {
                  if (!rdErrorsArray.includes(itemDif)) {
                    rdErrorsArray.push(itemDif);
                  }
                });
              }

              const differencesMap = dgItem.differences.map((dItem) => {
                uniqueId = uniqueId + 1;

                return {
                  ...dItem,
                  hidden: false,
                  uniqId: uniqueId,
                };
              });

              return { ...dgItem, differences: differencesMap };
            });

            dataMap = { ...data, difference_groups: differenceGroupsMap };

            /* data.difference_groups.forEach((item) => {
              if (item.difference_categories.length) {
                item.difference_categories.forEach((itemDif) => {
                  if (!rdErrorsArray.includes(itemDif)) {
                    rdErrorsArray.push(itemDif);
                  }
                });
              }
            }); */
          }

          setRdData(dataMap);
          setRdDataFull(dataMap);
          setRdErrors(rdErrorsSet ? rdErrorsSet : rdErrorsArray);
          setRdErrorsFull(rdErrorsArray);
          setLoadingFlag(false);

          console.log(dataMap);
        })
        .catch((error) => {
          console.log(error);
          setErrorInfo({
            error: true,
            message: error.response.data.includes("<html")
              ? error.response.data
              : JSON.stringify(error.response.data),
          });
        });
    };

    if (ordersIncluded.length && receipts.length) {
      rdResultsGet();
    }
  }, [
    currentPricing,
    dateRange,
    ordersIncluded,
    receipts,
    priceMargin,
    showPricingDifferences,
    rdErrorsSet,
  ]);

  useEffect(() => {
    const ordersMap = ordersSelected.map((item) => item.id);

    setOrdersIncluded(ordersMap);
    setRdOrders(ordersMap);
  }, [ordersSelected]);

  useEffect(() => {
    setReceipts(receiptsSelected.map((item) => item.id));
  }, [receiptsSelected]);

  /* useEffect(() => {
    const hideErrorsFunc = () => {
      setRdErrors(() => (hideErrors ? [] : rdErrorsFull));
    };

    if (!loadingFlag) {
      hideErrorsFunc();
    }
  }, [hideErrors, loadingFlag, rdErrorsFull]); */

  useEffect(() => {
    const filterRdData = () => {
      setRdData(() => {
        let differenceGroups = rdDataFull.difference_groups
          .filter((item) => {
            if (!rdErrors.length) return !item.difference_categories.length;

            return (
              item.difference_categories.some((dcItem) =>
                rdErrors.includes(dcItem)
              ) || !item.difference_categories.length
            );
          })
          .filter((item) =>
            hideNonErrors ? item.difference_categories.length : true
          );

        return { ...rdDataFull, difference_groups: differenceGroups };
      });

      if (rdErrorsFull.length && !rdErrors.length) {
        setHideErrors(true);
      }
    };

    if (rdDataFull && !loadingFlag) {
      filterRdData();
    }
  }, [hideNonErrors, loadingFlag, rdDataFull, rdErrors, rdErrorsFull]);

  return (
    <div className={classes.paper}>
      <Modal open={loadingFlag}>{loadingModalContent}</Modal>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ textAlign: "right" }}
          className="noprint"
        >
          {rdData && rdData.difference_groups.length ? (
            <>
              <IconButton
                style={{ marginLeft: theme.spacing(1) }}
                variant="contained"
                onClick={() => toggleDisplayPrint()}
                disabled={displayPrintFollow}
              >
                <PrintIcon color={displayPrint ? "info" : "inherit"} />
              </IconButton>
              <IconButton
                style={{ marginLeft: theme.spacing(1) }}
                variant="contained"
                onClick={() => toggleDisplayPrintFollow()}
                disabled={displayPrint}
              >
                <MediationIcon
                  color={displayPrintFollow ? "info" : "inherit"}
                />
              </IconButton>
            </>
          ) : (
            <>
              <IconButton
                style={{ marginLeft: theme.spacing(1) }}
                variant="contained"
              >
                <PrintIcon color="disabled" />
              </IconButton>
              <IconButton
                style={{ marginLeft: theme.spacing(1) }}
                variant="contained"
              >
                <MediationIcon color="disabled" />
              </IconButton>
            </>
          )}
        </Grid>
        {displayPrintFollow ? (
          <></>
        ) : (
          <>
            <Grid item xs={12} sm={12}>
              <Divider textAlign="right">
                <Tooltip title={`${displayDetails ? "Show" : "Hide"} details`}>
                  <Switch
                    checked={!displayDetails}
                    onChange={() => toggleDisplayDetails()}
                  />
                </Tooltip>
              </Divider>
              <Collapse in={!displayDetails}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="subtitle1">
                      <strong>Start Date: </strong>
                      {!isNaN(dateRange[0])
                        ? dateRange[0].toISOString().split("T")[0]
                        : dateRange[0].split("T")[0]}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>End Date: </strong>
                      {!isNaN(dateRange[1])
                        ? dateRange[1].toISOString().split("T")[0]
                        : dateRange[1].split("T")[0]}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>Included Orders: </strong>
                      {ordersIncluded.map((item) => {
                        const orderObj = orders.find(
                          (order) => order.id === item
                        );
                        return `${item} (${orderObj.customer.username}),`;
                      })}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>Receipt Selected: </strong>
                      {receipts.join(",")}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>Price Margin: </strong>
                      {priceMargin}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>Show pricing differences: </strong>
                      {"" + showPricingDifferences}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    {rdErrorsFull.length ? (
                      <>
                        <Typography variant="subtitle1">
                          <strong>Error filtering </strong>
                        </Typography>
                        {rdErrorsFull.map((item, idx) => (
                          <FormControlLabel
                            key={`rdError-${idx}`}
                            value="start"
                            control={
                              <Checkbox
                                name={`rdError-${idx}`}
                                value={item}
                                checked={rdErrors.includes(item)}
                                onChange={handleChangeErrorFiltering}
                                color="primary"
                              />
                            }
                            label={item.replace("DifferenceCategory.", "")}
                            labelPlacement="end"
                          />
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                  <Grid item xs={9}>
                    {ordersIncluded.length ? (
                      <>
                        <Typography variant="subtitle1">
                          <strong>Order filtering </strong>
                        </Typography>
                        {ordersIncluded.map((item, idx) => (
                          <FormControlLabel
                            key={`rdOrder-${idx}`}
                            value="start"
                            control={
                              <Checkbox
                                name={`rdError-${idx}`}
                                value={item}
                                checked={rdOrders.includes(item)}
                                onChange={handleChangeOrderFiltering}
                                color="primary"
                              />
                            }
                            label={item}
                            labelPlacement="end"
                          />
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              </Collapse>
            </Grid>
            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Link
                to={{
                  pathname: "/missingItems",
                  state: {
                    currentPricing: currentPricing,
                    dateRange: dateRange,
                    orders: orders,
                    ordersSelected: ordersSelected,
                    receiptsSelected: receiptsSelected,
                    priceMargin: priceMargin,
                    showPricingDifferences: showPricingDifferences,
                    rdErrorsSet: rdErrors,
                  },
                }}
              >
                <Button style={{ marginLeft: 8 }} variant="contained">
                  Missing Items
                </Button>
              </Link>
              <Button
                style={{ marginLeft: 8 }}
                color={showHiddenRows ? "success" : "inherit"}
                variant="contained"
                onClick={() => toggleShowHiddenRows()}
              >
                {`Show hidden rows (${hiddenRows})`}
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                // disabled={hideNonErrors}
                color={hideErrors ? "success" : "inherit"}
                variant="contained"
                onClick={() => toggleHideErrors()}
              >
                {`Hide errors`}
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                // disabled={hideErrors}
                color={hideNonErrors ? "success" : "inherit"}
                variant="contained"
                onClick={() => toggleHideNonErrors()}
              >
                {`Hide non errors`}
              </Button>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <TableContainer
            sx={{
              maxHeight: displayPrint || displayPrintFollow ? "auto" : 600,
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns
                    .filter((column) =>
                      displayPrintFollow
                        ? !["hidden", "receipt_item", "difference"].includes(
                            column.id
                          )
                        : true
                    )
                    .map((column) => (
                      <TableCell
                        key={`header-${column.id}`}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rdData && rdData.difference_groups.length ? (
                  rdData.difference_groups.map((group, index) =>
                    group.differences
                      .filter((difference) => {
                        if (!rdOrders.length) return true;

                        if (!difference.order_item) return true;

                        if (!difference.order_item.referenced_orders)
                          return true;

                        return difference.order_item.referenced_orders.some(
                          (roItem) => rdOrders.includes(roItem.order_id)
                        );
                      })
                      .filter((difference) =>
                        showHiddenRows ? true : !difference.hidden
                      )
                      .map(
                        (
                          { order_item, product, receipt_item, hidden, uniqId },
                          indexIn
                        ) => (
                          <TableRow
                            hover
                            tabIndex={-1}
                            key={`group-${index}-row-${indexIn}`}
                            style={{
                              background:
                                group.differences.length > 1
                                  ? "repeating-linear-gradient(45deg, transparent, transparent, rgb(195, 195, 195) 30px, rgb(245, 245, 245) 10px) fixed"
                                  : "inherit",
                              backgroundColor:
                                group.difference_categories.includes(
                                  "DifferenceCategory.NO_RECEIPT_ITEM"
                                ) ||
                                group.difference_categories.includes(
                                  "DifferenceCategory.NO_ORDER_ITEM"
                                )
                                  ? "#fcf8e3"
                                  : group.difference_categories.includes(
                                      "DifferenceCategory.UNIT_QUANTITY"
                                    ) ||
                                    group.difference_categories.includes(
                                      "DifferenceCategory.CASE_QUANTITY"
                                    ) ||
                                    group.difference_categories.includes(
                                      "DifferenceCategory.PRICE"
                                    )
                                  ? "#f2dede"
                                  : "inherit",
                            }}
                          >
                            {displayPrintFollow ? (
                              <></>
                            ) : (
                              <TableCell>
                                <Checkbox
                                  name={`${index}-${indexIn}-hidden-${uniqId}`}
                                  value={hidden}
                                  checked={hidden}
                                  onChange={handleChange}
                                />
                              </TableCell>
                            )}
                            <TableCell>
                              {product !== null ? (
                                <>
                                  <Typography variant="subtitle1">
                                    <strong>UPC: </strong>
                                    {product.upc}
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    <strong>Item Code: </strong>
                                    {product.item_code}
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    {product.name}
                                  </Typography>
                                  {order_item !== null &&
                                  order_item?.referenced_orders ? (
                                    <Typography variant="subtitle1">
                                      <strong>Order: </strong>
                                      <br />
                                      {order_item.referenced_orders.map(
                                        (oiRef) => {
                                          const orderObj = orders.find(
                                            (oItem) =>
                                              oItem.id === oiRef.order_id
                                          );

                                          return (
                                            <Fragment
                                              key={`${product.upc}-${oiRef.order_id}`}
                                            >
                                              <LinkE
                                                href={`/order/${oiRef.order_id}`}
                                                target="_blank"
                                              >
                                                {oiRef.order_id}
                                              </LinkE>
                                              {` (${orderObj.customer.username})`}
                                              {oiRef.base_unit_quantity ||
                                              oiRef.units_ordered
                                                ? ` U: ${oiRef.base_unit_quantity}/${oiRef.units_ordered}`
                                                : ""}
                                              {oiRef.base_case_quantity ||
                                              oiRef.cases_ordered
                                                ? ` C: ${oiRef.base_case_quantity}/${oiRef.cases_ordered}`
                                                : ""}
                                              <br />
                                            </Fragment>
                                          );
                                        }
                                      )}
                                    </Typography>
                                  ) : (
                                    <></>
                                  )}
                                  <Typography variant="subtitle1">
                                    <strong>Combined Stock: </strong>
                                    {`${product.combined_stock_level || "N/A"}`}
                                  </Typography>
                                </>
                              ) : (
                                <></>
                              )}
                            </TableCell>
                            <TableCell>
                              {order_item !== null ? (
                                <>
                                  <Typography variant="subtitle1">
                                    <strong>U: </strong>
                                    {order_item.unit_quantity}
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    <strong>C: </strong>
                                    {order_item.case_quantity}
                                  </Typography>
                                  {displayPrintFollow ? (
                                    <></>
                                  ) : (
                                    <Typography variant="subtitle1">
                                      <strong>Total: </strong>
                                      {order_item.total}
                                    </Typography>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </TableCell>
                            {displayPrintFollow ? (
                              <></>
                            ) : (
                              <>
                                <TableCell>
                                  {receipt_item !== null ? (
                                    <>
                                      <Typography variant="subtitle1">
                                        <strong>U: </strong>
                                        {receipt_item.unit_quantity}
                                      </Typography>
                                      <Typography variant="subtitle1">
                                        <strong>C: </strong>
                                        {receipt_item.case_quantity}
                                      </Typography>
                                      <Typography variant="subtitle1">
                                        <strong>Total: </strong>
                                        {receipt_item.total}
                                      </Typography>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {group.difference_categories
                                    .filter(
                                      (item) =>
                                        ![
                                          "DifferenceCategory.UNIT_TO_CASE_1TO1_OVERRIDE",
                                          "DifferenceCategory.CASE_TO_UNIT_1TO1_OVERRIDE",
                                          "DifferenceCategory.APPROXIMATE_PRICE",
                                          "DifferenceCategory.LINKED_UPC_1TO1",
                                        ].includes(item)
                                    )
                                    .map((category, catIndex) => (
                                      <Typography
                                        variant="subtitle1"
                                        key={`group-${index}-row-${indexIn}-category-${catIndex}`}
                                      >
                                        {category.replace(
                                          "DifferenceCategory.",
                                          ""
                                        )}
                                      </Typography>
                                    ))}
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        )
                      )
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      There are no difference results or they are all hidden
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
};

export default Difference;
